import React from 'react'
import { TawreedDropdownProps, TawreedMenuDropdown } from '../../../../../common/components/form'

export const DiscountTypesBasicsDropDown: React.FC<TawreedDropdownProps> = (props) => {

    return (<TawreedMenuDropdown {...props} menu="discountTypesBasics" />)
}
